import { CAMPAIGNS_STATUS_MESSAGES, CampaignsStatusMessages } from "./campaigns-status.messages";
import { CAMPAIGNS_TABLE_MESSAGES, CampaignsTableMessages } from "./campaigns-table.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { FILTER_MESSAGES, FiltersMessages } from "../inputs/filters.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";
import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";

export type CampaignsMessages = SidebarMessages &
  FiltersMessages &
  ActionButtonMessages &
  PopoverMessages &
  CampaignsStatusMessages &
  CampaignsTableMessages & {
    // Title messages
    pageTitle: string;
    campaignBreadCrumbTitle: string;

    //Popover
    statsPopover: string;

    // Button messages
    addCampaignButton: string;

    // Column messages
    campaignCodeColumn: string;
    campaignNameColumn: string;
    campaignTypeColumn: string;
    statusColumn: string;
    startValidityDateColumn: string;
    endValidityDateColumn: string;

    // Status messages
    statusActive: string;
    statusInactive: string;
    statusDraft: string;
    statusRejected: string;
    statusHold: string;
    statusCompleted: string;

    campaignTypePromotionalPrice: string;
    campaignTypeDiscountCoupon: string;
    campaignTypeSimpleMessage: string;

    // Filter messages
    moreFiltersButton: string;
    lessFiltersButton: string;
    clearFilterButton: string;
    filterButton: string;
  };

export const CAMPAIGNS_MESSAGES: CampaignsMessages = {
  ...CAMPAIGNS_TABLE_MESSAGES,
  ...CAMPAIGNS_STATUS_MESSAGES,
  ...POPOVER_MESSAGES,
  ...FILTER_MESSAGES,
  ...SIDEBAR_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
  pageTitle: "Campanhas",
  campaignBreadCrumbTitle: "Campanhas",
  statsPopover: "Estatísticas",
  addCampaignButton: "Nova Campanha",
  campaignCodeColumn: "Código",
  campaignNameColumn: "Nome",
  campaignTypeColumn: "Tipo",
  statusColumn: "Status",
  startValidityDateColumn: "Vigência Inicial",
  endValidityDateColumn: "Vigencia Final",
  statusActive: "Ativa",
  statusInactive: "Inativa",
  statusDraft: "Rascunho",
  statusRejected: "Rejeitada",
  statusHold: "Aguardando Aprovação",
  statusCompleted: "Concluída",
  campaignTypePromotionalPrice: "Preço Promocional",
  campaignTypeDiscountCoupon: "Cupom de Desconto",
  campaignTypeSimpleMessage: "Mensagem Simples",
  moreFiltersButton: "Mais Filtros",
  lessFiltersButton: "Menos Filtros",
  clearFilterButton: "Limpar Filtros",
  filterButton: "Filtrar",
};
